import React, { useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ErrorIcon from "../../../assets/images/404-image.png";

const SystemDownTime = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.body.classList.add("gray-background");
  }, []);
 

  return (
    <Container className="systemdown">
      <Row>
        <Col lg={{ span: 8, offset: 2 }}>
          <div role="alert" aria-live="assertive" className="systemdown__block">
            <img
              src={ErrorIcon}
              alt="Error Icon"
              aria-hidden="true"
              className="systemdown__block-icon"
            />
            <h1 className="systemdown__block-title">
              {t("pages.systemDown.title")}
            </h1>      
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default SystemDownTime;